  export const settingsNames = {
  account: 'account',
  privacy: 'privacy',
  appearance: 'appearance',
  language: 'language',
  support: 'support',
} as const

export type SettingName = typeof settingsNames[keyof typeof settingsNames]

export const MIN_FONT_SCALE = 1
export const MAX_FONT_SCALE = 4
export const STEP_FONT_SCALE = 1

export const scaleMap: Record<number, number> = {
  1: 1,
  2: 1.1,
  3: 1.2,
  4: 1.3
}

export const Themes = {
  system: 'system',
  light: 'light',
  dark: 'dark'
} as const

export type Theme = typeof Themes[keyof typeof Themes]

